module.exports = __webpack_public_path__ + "media/images/icons/chevron-circle-right-fb606d43d77dfd3b39115b001f9f2a81.svg";